import React, { useEffect, useState } from "react";
import Canvas from "./components/Canvas/Canvas";
import { getBook } from "./lib/dato/client";

function App(props) {
  const [currentBook, setCurrentBook] = useState<any>();
  useEffect(() => {
    async function log() {
      const data = await getBook(props.bookSlug);
      setCurrentBook(data);
    }
    log();
  }, [props.bookSlug]);

  return (
    <div className="App">{currentBook && <Canvas data={currentBook} />}</div>
  );
}

export default App;
